import React from 'react';
import PropTypes from 'prop-types';

import { Panel } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';
import PropertyType from './property_type';

import './styles.scss';

export default function CompanyGridPropertyTypes({ companyGrid, onChange }) {
  return <React.Fragment>
    <h4>Property Types</h4>

    <Panel>
      <Panel.Body className="company-grid-property-types-panel">
        <ManagedInput
          checked={companyGrid.createShadowOnPropertyCreate}
          name="createShadowOnPropertyCreate"
          type="checkbox"
          onChange={onChange}
        >
          Auto-create grid for new listings of the selected property type(s)
        </ManagedInput>
      </Panel.Body>
    </Panel>

    <Panel>
      <Panel.Body className="company-grid-property-types-panel">
        {Object.values(companyGrid.propertyTypesById).map(propertyType => (
          <PropertyType
            key={propertyType.id}
            propertyType={propertyType}
            onChange={propertyType => onChange({
              propertyTypesById: {
                ...companyGrid.propertyTypesById,
                [propertyType.id]: propertyType,
              }
            })}
          />
        ))}
      </Panel.Body>
    </Panel>
  </React.Fragment>;
}

CompanyGridPropertyTypes.propTypes = {
  companyGrid: PropTypes.shape({
    createShadowOnPropertyCreate: PropTypes.bool,
    propertyTypesById: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};
